<template>
  <section class="section-show-more">
    <div class="button">
      <a href="#" class="btn btn-full btn-show-more">{{ template.cta }}</a>
    </div>
  </section>
</template>

<script>
export default {
  name: 'More',

  data() {
    return {
      template: null,
    };
  },

  beforeMount() {
    this.template = this.$store.state.template.home.more;
  },
};
</script>

<style lang="scss">
.section-show-more {
  display: flex;
  position: relative;
  align-items: center;
  align-content: center;
  background-image: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://proto-assets.s3.amazonaws.com/blitzar-lite/touch.jpg');
  background-size: cover;
  background-position: center;
  height: 100dvh; /* 100% da viewport */
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn-show-more a:link,
.btn-show-more a:visited {
  text-align: center;
  font-weight: normal;
  opacity: 0.75;
  transition: opacity 0.3s;
}
.btn-show-more a:hover {
  opacity: 1;
}
</style>
